import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  imports: [],
  templateUrl: './star-rating.component.html',
  styleUrl: './star-rating.component.scss',
})
export class StarRatingComponent {
  @Input() stars = 5;
  @Input() rating = 0;
  @Output() ratingChange = new EventEmitter<number>();
  hovered = 0;
  hasInteracted = false;
  setRating(value: number) {
    this.rating = value;
    this.hasInteracted = true;
    this.ratingChange.emit(this.rating);
  }

  handleKeydown(event: KeyboardEvent, currentValue: number): void {
    let nextValue: number | null = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowUp':
        nextValue = Math.min(currentValue + 1, this.stars);
        break;
      case 'ArrowLeft':
      case 'ArrowDown':
        nextValue = Math.max(currentValue - 1, 1);
        break;
      case 'Home':
        nextValue = 1;
        break;
      case 'End':
        nextValue = this.stars;
        break;
      case 'Enter':
      case ' ':
        nextValue = currentValue;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.setRating(nextValue);
    const star = (event.currentTarget as HTMLElement).parentElement?.querySelector<HTMLElement>(`[data-rating="${nextValue}"]`);
    star?.focus();
  }

  setHover(value: number) {
    this.hovered = value;
  }

  clearHover() {
    this.hovered = 0;
  }

  getColor(index: number) {
    if (!this.hasInteracted) {
      return '#D9D9D9';
    }
    return index < this.rating ? 'gold' : '#D9D9D9';
  }
}
